import { getKeys, hasMissingSchemaVariables } from '../../adapters/utils';
import { renderStructureData, getServiceUrl, getUrlParts, } from './adapter-utils';
import { get, getRawValue } from '../../utils/get';
import { buildOgImagePreviewUrl } from '../../utils/build-og-image-preview';
export var IDs = {
    CALCULATED_SERVICE_URL: 'service.url',
    NAME: 'service.info.name',
    DESCRIPTION: 'service.info.description',
    STATUS: 'service.status',
    SERVICE_ID: 'service.id',
    IMAGE_HEIGHT: 'service.mainImage.height',
    IMAGE_ID: 'service.mainImage.id',
    IMAGE_WIDTH: 'service.mainImage.width',
    IMAGE_URL: 'service.mainImage.url',
    CATEGORY_NAME: 'service.category.name',
    PRICE_AMOUNT: 'service.price.amount',
    CURRENCY: 'service.price.currency',
    START_DATE: 'service.start-date',
    END_DATE: 'service.end-date',
    PRICE_TEXTUAL: 'service.price.textual',
    SESSION_TYPE: 'service.type',
    FIRST_SESSION: 'service.session.first',
    LAST_SESSION: 'service.session.last',
    SD_DISABLE_SCHEMA: 'service.disable-schema',
    SD_JSON_RENDER: 'service.structured-data.render',
    SD_DISABLE_SERVICE_SCHEMA: 'service.structured-data.disable-service-schema',
    SD_DISABLE_COURSE_SCHEMA: 'service.structured-data.disable-course-schema',
};
var userVisible = [
    IDs.NAME,
    IDs.DESCRIPTION,
    IDs.SESSION_TYPE,
    IDs.CALCULATED_SERVICE_URL,
    IDs.IMAGE_URL,
    IDs.PRICE_AMOUNT,
    IDs.CURRENCY,
];
var requiredSchemaVariables = [];
var SchemaTypes = {
    BOOKINGS_SERVICE: 'bookings-service-preset',
    BOOKINGS_COURSE: 'bookings-course-preset',
};
var SESSION_TYPES = {
    COURSE: 'course',
    SERVICE: 'service',
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    requiredSchemaVariables: requiredSchemaVariables,
    getData: function (item) {
        var _a;
        var serviceResponse = item.serviceResponse;
        var sessionType = get(serviceResponse, 'schedules.0.tags.0').toLowerCase() ===
            SESSION_TYPES.COURSE
            ? SESSION_TYPES.COURSE
            : SESSION_TYPES.SERVICE;
        var imageData = getRawValue(serviceResponse, 'service.info.images.0') || {};
        var data = (_a = {},
            _a[IDs.CALCULATED_SERVICE_URL] = getServiceUrl(serviceResponse),
            _a[IDs.NAME] = get(serviceResponse, 'service.info.name'),
            _a[IDs.DESCRIPTION] = get(serviceResponse, 'service.info.description'),
            _a[IDs.STATUS] = get(serviceResponse, 'service.status') || 'CREATED',
            _a[IDs.SERVICE_ID] = get(serviceResponse, 'service.id'),
            _a[IDs.IMAGE_HEIGHT] = imageData.height || '',
            _a[IDs.IMAGE_WIDTH] = imageData.width || '',
            _a[IDs.IMAGE_URL] = buildOgImagePreviewUrl(imageData) || '',
            _a[IDs.CATEGORY_NAME] = get(serviceResponse, 'category.name'),
            _a[IDs.PRICE_AMOUNT] = get(serviceResponse, 'schedules.0.rate.labeledPriceOptions.general.amount'),
            _a[IDs.CURRENCY] = get(serviceResponse, 'schedules.0.rate.labeledPriceOptions.general.currency'),
            _a[IDs.START_DATE] = get(serviceResponse, 'schedules.0.availability.start'),
            _a[IDs.END_DATE] = get(serviceResponse, 'schedules.0.availability.end'),
            _a[IDs.PRICE_TEXTUAL] = get(serviceResponse, 'schedules.0.rate.priceText'),
            _a[IDs.SESSION_TYPE] = sessionType,
            _a[IDs.FIRST_SESSION] = get(serviceResponse, 'schedules.0.firstSessionStart'),
            _a[IDs.LAST_SESSION] = get(serviceResponse, 'schedules.0.lastSessionEnd'),
            _a[IDs.SD_DISABLE_SCHEMA] = hasMissingSchemaVariables(requiredSchemaVariables, serviceResponse),
            _a[IDs.SD_DISABLE_SERVICE_SCHEMA] = sessionType === SESSION_TYPES.COURSE,
            _a[IDs.SD_DISABLE_COURSE_SCHEMA] = sessionType === SESSION_TYPES.SERVICE,
            _a);
        data[IDs.SD_JSON_RENDER] = renderStructureData(item, data, IDs);
        return data;
    },
    getLegacySeoBlob: function () { return ({ tags: [] }); },
    getSlug: function (item) { return get(item, 'serviceResponse.slugs.0.name') || ''; },
    getFullUrl: function (item) { return getServiceUrl(getRawValue(item, 'serviceResponse')); },
    setFullUrl: function (item, url) {
        if (url === void 0) { url = ''; }
        item = JSON.parse(JSON.stringify(item));
        var _a = getUrlParts(url), base = _a.base, path = _a.path;
        item.serviceResponse.urls.servicePageUrl.base = base;
        item.serviceResponse.urls.servicePageUrl.path = path;
        return item;
    },
    updateItemDataWithSlug: function (itemData, slugValue) {
        var updatedItemData = JSON.parse(JSON.stringify(itemData));
        var oldSlug = get(updatedItemData, 'serviceResponse.slugs.0.name');
        if (oldSlug !== '') {
            updatedItemData.serviceResponse.slugs[0].name = slugValue;
        }
        return updatedItemData;
    },
    getBiData: function (item) { return ({
        id: get(item, 'service.id'),
        name: get(item, 'service.info.name'),
    }); },
    getKeys: function () { return getKeys(IDs, userVisible); },
};
